import React, { ChangeEventHandler, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { stringify } from "qs";

import { Category } from "constants/events";
import { useEventTracker } from "hooks/useEventTracker";
import parseNextRouterAsPath from "utils/parseNextRouterAsPath";

import SearchInput from "components/SearchInput";
import TrackImpression from "components/TrackImpression";
import FulfillmentInfoBanner from "components/UnifiedShop/FulfillmentBanner";

const Header: React.FC = () => {
  const { publishEvent } = useEventTracker();
  const { asPath, push } = useRouter();
  const { path, query: parsedQs } = parseNextRouterAsPath(asPath);
  const { q: _q, page: _page, ...other } = parsedQs;
  const query = parsedQs.q as string;

  const setQuery = (value?: string) => {
    push({
      pathname: path,
      query: stringify(
        {
          ...other,
          q: value,
        },
        { arrayFormat: "brackets", indices: false },
      ),
    });
  };

  // * Local component state for input
  const [inputValue, setInputValue] = useState(query || "");
  // * Used to track the initial q parameter on page load
  const [initialSearch, _] = useState(query);

  const triggerSearch = (value: string) => {
    publishEvent({
      action: "click",
      category: Category.unifiedShoppingExperience,
      label: "search bar",
      searchedFor: value,
    });
    setQuery(value);
  };

  const changeHandler: ChangeEventHandler<HTMLInputElement> = (e) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    // * Sync local input state with quey param, if the query param
    // * is updated elsewhere.
    setInputValue(query || "");
  }, [query]);

  return (
    <div className="mb-sm md:mb-xl">
      <FulfillmentInfoBanner />
      <div className={`container mt-lg`}>
        <TrackImpression
          className=""
          category={Category.unifiedShoppingExperience}
          label="search button"
          customDimensions={{
            default_option: initialSearch,
          }}
        >
          <SearchInput
            inputProps={{
              className: "h-12",
              onChange: changeHandler,
              onKeyDown: (e) => {
                if (e.key && e.key !== "Enter") {
                  return;
                }

                triggerSearch(inputValue);
              },
              placeholder: "Search products",
              value: inputValue,
            }}
            clearButtonProps={{
              onClick: () => setQuery(),
            }}
            searchButtonProps={{
              onClick: () => triggerSearch(inputValue),
            }}
          />
        </TrackImpression>
      </div>
    </div>
  );
};

export default Header;
